import React from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';

import { PAGE_DIRECTORY } from '../../../services/filter/constants';
import { reductionDirectoryRoutes } from '../../../routes/directory';

import { clearFilter, clearSort } from '../../../services/filter/actions';

import { mapRoutes } from '../../../utils/routeUtils';

class ReductionDirectoryPage extends React.Component {
    componentWillUnmount() {
        this.props.clearFilter(PAGE_DIRECTORY);
        this.props.clearSort(PAGE_DIRECTORY);
    }

    render() {
        return (
            <div>
                <Switch>{mapRoutes(reductionDirectoryRoutes)}</Switch>
            </div>
        );
    }
}

const mapDispatchToProps = {
    clearFilter,
    clearSort
};

export default connect(null, mapDispatchToProps)(ReductionDirectoryPage);



// WEBPACK FOOTER //
// ./src/components/pages/directory/ReductionDirectoryPage.js